import { render } from "./BatchNumberChangeModal2.vue?vue&type=template&id=4d83ae96"
import script from "./BatchNumberChangeModal2.vue?vue&type=script&lang=js"
export * from "./BatchNumberChangeModal2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__